import { createActions, createReducer } from 'reduxsauce'

import ConsultaPlanoAnualContratacoesService from '../../servicos/ConsultaPlanoAnualContratacoesService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaPlanoAnualContratacoesInicio: [],
    buscaConsultaPlanoAnualContratacoesErro: ['erro'],
    buscaConsultaPlanoAnualContratacoesSucesso: ['consultaPlanoAnualContratacoes'],
    limpar: [],
    setConsultaPlanoAnualContratacoesEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaPlanoAnualContratacoes = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaPlanoAnualContratacoesInicio())
        let serv = new ConsultaPlanoAnualContratacoesService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaPlanoAnualContratacoesSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaPlanoAnualContratacoesErro(error)))
    }
}

const buscaConsultaPlanoAnualContratacoesInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaPlanoAnualContratacoesErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaConsultaPlanoAnualContratacoesSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaPlanoAnualContratacoes.resultado,
        dataSincronizacaoDados: action.consultaPlanoAnualContratacoes.dataSincronizacaoDados,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaPlanoAnualContratacoesEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_PLANO_ANUAL_CONTRATACOES_INICIO]: buscaConsultaPlanoAnualContratacoesInicio,
    [Types.BUSCA_CONSULTA_PLANO_ANUAL_CONTRATACOES_ERRO]: buscaConsultaPlanoAnualContratacoesErro,
    [Types.BUSCA_CONSULTA_PLANO_ANUAL_CONTRATACOES_SUCESSO]: buscaConsultaPlanoAnualContratacoesSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_PLANO_ANUAL_CONTRATACOES_ESTADO_DT]: setConsultaPlanoAnualContratacoesEstadoDT,
})
